export default "__VITE_ASSET__BYVljJw6__"